// extracted by mini-css-extract-plugin
export default {"input-styles":"Input_input-styles__-a66+"};